<template>
  <div>
    <table style="position: absolute;" width="100%" :height="windowSize.height - 8" :max-height="windowSize.height - 8">
      <tr max-height="48px" height="48px">
        <ContenidoBase
          :titulo="'Reporte Ventas Guaguas Calientes'"
          :descripcion="'Imprime las ventas guaguas calientes'"
          :EstadoBtn="EstadoBtn"
          @abrirBarraTablaDinamica="abrirTabla"
          @MethodNuevo="newwnuevo"
          @MethodGuardar="save"
          @MethodEliminar="remove"
          @MethodAnular="anular"
          @MethodImprimir="imprimirList"
        />
      </tr>

      <tr>
        <td width="109" :max-height="windowSize.height - 96" v-show="BarraTablaDinamicaAprir">
          <div class="overflow-y-auto" v-bind:style="{ 'max-height': windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }"></div>
        </td>

        <td :max-height="windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto" v-bind:style="{ 'max-height': windowSize.height - 96 + 'px' }">
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000;">
                  <v-avatar tile size="45">
                    <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte">
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px;">Reporte Ventas Guaguas Calientes</span>
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          dense
                          outlined
                          type="date"
                          label="Desde:"
                          :rules="[$rules.required]"
                          v-model="VentasGuaguasCalientes.desde"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>

                        <v-combobox
                          autocomplete="off"
                          dense
                          outlined
                          label="Sucursal:"
                          :items="sucursales"
                          item-text="descripcion"
                          v-model="VentasGuaguasCalientes.sucursal"
                          @focus="cargarSucursales"
                          @blur="SelctCbSucursal"
                        >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-building"></i>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col cols="12" md="6" sm="6">
                        <v-text-field
                          dense
                          outlined
                          type="date"
                          label="Hasta:"
                          :rules="[$rules.required]"
                          v-model="VentasGuaguasCalientes.hasta"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>

                        <v-combobox
                          autocomplete="off"
                          dense
                          outlined
                          label="Propietario / Chofer:"
                          :items="Rpropietario"
                          item-text="nombre"
                          v-model="VentasGuaguasCalientes.propietario"
                          @focus="cargarPropietario"
                          @blur="SelctCbPropietario"
                        >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-street-view"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>

                <hr>

                <ModalReporteFiltros
                  @DataReporteBasico="DDataReporteBasico"
                  :Datos="VentasGuaguasCalientes"
                />
              </v-card>
            </v-container>
          </v-app>
        </td>

        <td width="109" :max-height="windowSize.height - 96" v-show="BarraSecundariaAprir">
          <div class="overflow-y-auto" v-bind:style="{ 'max-height': windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }"></div>
        </td>
      </tr>
    </table>

    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";

export default {
  components: {
    ContenidoBase,
    ModalReporteFiltros,
  },
  created() {
    var json = {
      titulo: "Reporte Ventas Guaguas Calientes",
      descripcion: "Imprime las ventas guaguas calientes",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,
      accion: [
        "TranspVentasGuaguasCalientesNew",
        "TranspVentasGuaguasCalientesSave",
        "TranspVentasGuaguasCalientesRemove",
        "TranspVentasGuaguasCalientesAnular",
        "TranspVentasGuaguasCalientesPrintList",
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    EventBus.$on("onResize", this.onResize);
  },
  data: () => ({
    Rpropietario: [],
    sucursales: [],
    windowSize: { width: "auto", height: "auto" },
    VentasGuaguasCalientes: {
      nombre: "REPORTE VENTAS GUAGUAS CALIENTES",
      UrlImprimir: "/reportestrans/ImprimirVentasGuaguasCalientes",
      UrlExel: "/reportestrans/ExcelVentasGuaguasCalientes",
      UrlCorreo: "/reportestrans/CorreoVentasGuaguasCalientes",
      sucursal: null,
      propietario: null,
      desde: new Date().toISOString().substr(0, 10),
      hasta: new Date().toISOString().substr(0, 10),
    },
    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,
    aalert: {
      estado: false,
      color: null,
      nombre: "",
    },
  }),
  methods: {
    onResize(e) {
      this.windowSize = e;
    },
    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },
    save() {},
    remove() {},
    eliminar() {},
    anular() {},
    imprimirList() {},
    DDataReporteBasico() {},
    newwnuevo() {
      this.VentasGuaguasCalientes.sucursal = null;
      this.VentasGuaguasCalientes.propietario = null;
      this.VentasGuaguasCalientes.desde = new Date().toISOString().substr(0, 10);
      this.VentasGuaguasCalientes.hasta = new Date().toISOString().substr(0, 10);
    },
    cargarSucursales() {
      this.$axios
        .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.sucursales = res.data;
        })
        .catch((error) => console.log(error));
    },
    SelctCbSucursal() {
      if (this.VentasGuaguasCalientes.sucursal == null) {
        this.VentasGuaguasCalientes.sucursal = "";
      }
      if (this.VentasGuaguasCalientes.sucursal.codigo == undefined) {
        this.VentasGuaguasCalientes.sucursal = "";
      }
    },
    cargarPropietario() {
      this.$axios
        .get(this.$hostname + this.$hName + "/propietario/findallPropietarioActivos/", { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.Rpropietario = res.data;
        })
        .catch((error) => console.log(error));
    },
    SelctCbPropietario() {
      if (this.VentasGuaguasCalientes.propietario == null) {
        this.VentasGuaguasCalientes.propietario = "";
      }
      if (this.VentasGuaguasCalientes.propietario.id == undefined) {
        this.VentasGuaguasCalientes.propietario = "";
      }
    },
    BlurDesde() {
      if (this.VentasGuaguasCalientes.desde.toString().length == 0) {
        this.VentasGuaguasCalientes.desde = new Date().toISOString().substr(0, 10);
      }
    },
    BlurHasta() {
      if (this.VentasGuaguasCalientes.hasta.toString().length == 0) {
        this.VentasGuaguasCalientes.hasta = new Date().toISOString().substr(0, 10);
      }
    },
    alerta(e, l) {
      if (l == "bien") {
        this.aalert.estado = true;
        this.aalert.color = "success";
        this.aalert.nombre = e;
      }
      if (l == "error") {
        this.aalert.estado = true;
        this.aalert.color = "error";
        this.aalert.nombre = e;
      }
    },
  },
};
</script>
